/* import __COLOCATED_TEMPLATE__ from './fin-banner-base.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';

interface Args {
  title: string;
  ctaText: string;
  dismissible: boolean;
  onCtaClick: () => void;
  onDismiss?: () => void;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class FinBannerBase extends Component<Signature> {
  @service declare intercomEventService: $TSFixMe;
  @service declare router: RouterService;

  get location(): string {
    return this.router.currentRouteName || '';
  }

  @action
  handleCtaClick() {
    this.args.onCtaClick();

    this.router.transitionTo(this.router.currentRouteName, {
      queryParams: {
        ...this.router.currentRoute.queryParams,
        finOffer: 'true',
      },
    });
  }

  @action
  handleDismissClick() {
    if (this.args.onDismiss) {
      this.args.onDismiss();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'IncentiveOffer::Banners::FinBannerBase': typeof FinBannerBase;
    'incentive-offer/banners/fin-banner-base': typeof FinBannerBase;
  }
}
